module.exports = __webpack_public_path__ + "static/media/2_of_clubs.2c2e3c25.png";